// src/components/ResumeBuilder/forms/TrainingCertForm.jsx
import React, { useContext } from "react";
import {
  Box,
  Card,
  Grid,
  TextField,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { FieldArray, Formik, Form } from "formik";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import GradientButton from "../Button";
import { ResumeContext } from "../../ResumeContext";
import { saveResumeData } from "../../api/resumeapi";
import BasicInfoSkeleton from "./skeletonLoader";
import { TrainingCertSchema } from "./resumevalidation";

export default function TrainingCertForm({ onNext }) {
  const { data, setData, loading } = useContext(ResumeContext);
  console.log("TrainingForm data:", data);

  //  Skeleton while loading
  if (loading || !data) {
    return <BasicInfoSkeleton />;
  }

  return (
    <Card sx={{ p: 3, borderRadius: 2, boxShadow: 2 }}>
      <Typography fontSize={13} color="#6E6D81" mb={2}>
        Share with us your upskilling journey
      </Typography>

      <Formik
        enableReinitialize
        initialValues={{
          certificates:
            Array.isArray(data?.trainingArr) &&
              data.trainingArr.length > 0
              ? data.trainingArr
              : [{ title: "", issuer: "", year: "" }],
        }}
        validationSchema={TrainingCertSchema}
        validateOnBlur
        validateOnChange
        validateOnMount
        onSubmit={async (values) => {
          const trainingArr = values.certificates;

          const payload = {
            ...data,
            trainingArr,
          };

          try {
            // SAVE TO DB
            console.log("Saving Certificates:", values.certificates,payload);
            await saveResumeData(payload);

            // UPDATE CONTEXT
            setData((prev) => ({
              ...prev,
              trainingArr,
            }));
          } catch (err) {
            console.error("CERTIFICATE SAVE ERROR:", err);
          }
        }}
      >
        {({ values, handleChange, errors, touched }) => (
          <Form>
            <FieldArray name="certificates">
              {({ push, remove }) => (
                <Box>
                  {values.certificates.map((c, idx) => (
                    <Grid
                      container
                      spacing={2}
                      key={idx}
                      sx={{ mb: 1 }}
                      alignItems="center"
                    >
                      <Grid size={{ xs: 12, sm: 5 }}>
                        <TextField
                          fullWidth
                          label="Title"
                          name={`certificates[${idx}].title`}
                          size="small"
                          value={c.title}
                          onChange={handleChange}
                          error={
                            touched.certificates?.[idx]?.title &&
                            Boolean(errors.certificates?.[idx]?.title)
                          }
                          helperText={
                            touched.certificates?.[idx]?.title &&
                            errors.certificates?.[idx]?.title
                          }
                        />
                      </Grid>

                      <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField
                          fullWidth
                          label="Issuer"
                          name={`certificates[${idx}].issuer`}
                          size="small"
                          value={c.issuer}
                          onChange={handleChange}
                          error={
                            touched.certificates?.[idx]?.issuer &&
                            Boolean(errors.certificates?.[idx]?.issuer)
                          }
                          helperText={
                            touched.certificates?.[idx]?.issuer &&
                            errors.certificates?.[idx]?.issuer
                          }
                        />
                      </Grid>

                      <Grid size={{ xs: 12, sm: 2 }}>
                        <TextField
                          fullWidth
                          label="Year"
                          name={`certificates[${idx}].year`}
                          size="small"
                          value={c.year}
                          onChange={handleChange}
                          error={
                            touched.certificates?.[idx]?.year &&
                            Boolean(errors.certificates?.[idx]?.year)
                          }
                          helperText={
                            touched.certificates?.[idx]?.year &&
                            errors.certificates?.[idx]?.year
                          }
                        />
                      </Grid>

                      <Grid size={{ xs: 12, sm: 1 }} textAlign="right">
                        <IconButton
                          onClick={() => remove(idx)}
                          disabled={values.certificates.length === 1}
                          color="error"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}

                  <Button
                    startIcon={<AddIcon />}
                    onClick={() =>
                      push({ title: "", issuer: "", year: "" })
                    }
                  >
                    Add certificate
                  </Button>
                </Box>
              )}
            </FieldArray>

            {/* BUTTONS */}
            <Box mt={3} display="flex" justifyContent="center" gap={4}>
              <GradientButton
                type="button"
                onClick={onNext}
              >
                Next
              </GradientButton>

              <GradientButton type="submit">
                Save
              </GradientButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Card>
  );
}
